import React from 'react';

const Settings = () => <div>Settings Page</div>;

export default Settings; 